import { useNavigate, useParams } from "react-router-dom";

import MainContainer from "../../layout/MainContainer";

import {
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useState } from "react";

const AddCommission = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [visaType, setVisaType] = useState("default");

  const handleVisaType = (event: SelectChangeEvent) => {
    setVisaType(event.target.value as string);
  };
  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>{id ? "Edit" : "Add"} Documents</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-documents")}>Documents</span>{" "}
            - {id ? "Edit" : "Add"} Documents
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            {/* <div className="control_group w_100">
              <label> Image</label>
              <div className="upload_box">
                <label>
                  {visaImage && (
                    <IconButton
                      className="crossIcon"
                      onClick={() => setVisaImage("")}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                  <figure>
                    <img
                      src={visaImage ? visaImage : "/static/images/picture.png"}
                      alt="Upload"
                    />
                  </figure>
                  <IconButton className="uploadIcon">
                    <label htmlFor="icon-button-file">
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={(e: any) => {
                            handleBlogUpload(e);
                            e.target.value = null;
                          }}
                        />
                      </Button>
                    </label>
                  </IconButton>
                </label>
              </div>
            </div> */}

            <div className="control_group w_50">
              <label>Select Visa Type</label>
              <Select
                fullWidth
                labelId="visaType"
                id="visaType"
                value={visaType}
                onChange={handleVisaType}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                <MenuItem value={10}>Business Visa</MenuItem>
                <MenuItem value={20}>Study Visa</MenuItem>
                <MenuItem value={20}>Work Visa</MenuItem>
                <MenuItem value={20}>Visit Visa</MenuItem>
              </Select>
            </div>

            <div className="control_group w_50">
              <label>Document Name</label>
              <TextField
                variant="outlined"
                placeholder="Document Name"
                fullWidth
                hiddenLabel
              />
            </div>
          </div>

          <div className="form_end_btn">
            <Button
              className="btn btn_secondary"
              onClick={() => navigate("/manage-documents")}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddCommission;
